/* eslint react/no-did-mount-set-state: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import * as uuid from "react-native-uuid";
import Client from "../../Client";
import { DEFAULT_RUNSHEET, DEFAULT_JOB } from "../../types";
import RunsheetController from "./RunsheetController";

class RunsheetCreate extends Component {
  state = {
    fetched: false,
    runsheet: DEFAULT_RUNSHEET,
    errors: {}
  };

  componentDidMount() {
    const scheduledAt = moment().toISOString();
    const initialJob = { ...DEFAULT_JOB, externalId: uuid.v4(), seq: 1 };
    const runsheet = {
      ...this.state.runsheet,
      scheduledAt,
      jobs: [initialJob]
    };
    this.setState({ runsheet, fetched: true });
  }

  handleChange = runsheet => {
    this.setState({ runsheet });
    Client.createRunsheet(runsheet)
      .then(response => this.props.history.push(`/runsheets/${response.id}`))
      .catch(error => {
        const errorMessage = error.response.data.error;
        if (
          errorMessage.includes("An active runsheet already exists with id of")
        ) {
          const errors = { externalId: errorMessage.split(":")[1].trim() };
          this.setState({ errors });
        }
      });
  };

  render() {
    if (this.state.fetched) {
      const { errors } = this.state;
      return (
        <RunsheetController
          initialRunsheet={this.state.runsheet}
          mode="CREATE"
          history={this.props.history}
          onChange={this.handleChange}
          createErrors={errors}
        />
      );
    }

    return <p>Loading...</p>;
  }
}
RunsheetCreate.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired
};

export default RunsheetCreate;



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetCreate.js